exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".record[data-v-205fb15a] {\n  padding: 15px;\n}\n.record[data-v-205fb15a]:not(:last-child) {\n    border-bottom: 1px solid #ddddde;\n}\n.record p[data-v-205fb15a] {\n    margin: 6px 0;\n    font-size: 14px;\n}\n.record .title[data-v-205fb15a] {\n    font-size: 20px;\n}\n.record .title__number[data-v-205fb15a] {\n      color: #005fb3;\n}\n.record .docs__list[data-v-205fb15a] {\n    list-style-type: disc;\n}\n", ""]);

// exports
